import React from 'react';
import { Modal, DatePicker, Form, Select, Icon, Button, Table, Empty } from 'antd';
import moment from 'moment';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }
    handleBuscar = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const form = {
                    fechaDocumentosStr: values.fechaDocumentosStr.format("DD/MM/YYYY"),
                    idCliente: values.idCliente == undefined ? 0 : values.idCliente.key,
                }
                this.props.onBuscar(form, this.props.form);
            }
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Resumen Diario" : "Modificar Resumen Diario"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.props.onSave}
                style={{ top: 30 }}
                width="1100px"
            >
                <Form>


                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Selecciona una Fecha">
                                {getFieldDecorator("fechaDocumentosStr", {
                                    initialValue: moment(
                                        this.props.formValues.fechaDocumentosStr,
                                        "DD/MM/YYYY"
                                    ),
                                })(
                                    <DatePicker
                                        className="first-input"
                                        placeholder="Seleccione fecha"
                                        allowClear={false}
                                        onChange={(moment, value) => this.props.handleChangeView('fechaDocumentosStr', value)}
                                        prefix={
                                            <Icon
                                                type="filter"
                                                style={{ color: "rgba(0,0,0,.25)" }}
                                            />
                                        }
                                        format="DD/MM/YYYY"
                                    />
                                )}
                            </Form.Item>

                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Cliente">
                                {getFieldDecorator('idCliente', {
                                    initialValue: this.props.formValues.idCliente > 0 ?
                                        { key: this.props.formValues.idCliente } : undefined,
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Cliente"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.handleChangeView("idCliente", option.key)} //STATE PROPERTY

                                    >
                                        <Option key={0} value={0} >TODOS</Option>
                                        {this.props.formValues.clientes.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label=".">
                                <Button
                                    type="success"
                                    icon="search"
                                    loading={this.props.loadingSearch}
                                    onClick={this.handleBuscar}
                                    block>
                                    Buscar
                                </Button>
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto', marginTop: 10 }}
                                rowKey={record => record.serieDocumento}
                                dataSource={this.props.formValues.dataSource.data}
                                rowClassName='cursor-pointer'
                                rowSelection={{
                                    onChange: this.props.onSelect,
                                    selectedRowKeys: this.props.formValues.selectedRowKeys,
                                    hideDefaultSelections: false,
                                }}
                                onChange={(pagination, filters, sorter) => {
                                    this.props.onChange({
                                        page: pagination.current,
                                        order: sorter.order,
                                        field: sorter.field
                                    })
                                }}


                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr'
                                    },
                                    {
                                        title: 'Cliente',
                                        dataIndex: 'razonSocialCliente',
                                        key: 'razonSocialCliente'
                                    },
                                    {
                                        title: 'Tipo de Comprobante',
                                        dataIndex: 'nombreTipoComprobante',
                                        key: 'nombreTipoComprobante'
                                    },
                                    {
                                        title: 'Serie / Documento',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        render: (data, row) => (
                                            <span>{row.serie}-{row.documento}</span>
                                        )
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        align: 'right',
                                        render: (data) => (
                                            <span>{data.toFixed(2)}</span>
                                        )
                                    }
                                ]}

                                pagination={{
                                    total: this.props.formValues.dataSource.total,
                                    current: this.props.formValues.dataSource.page,
                                    pageSize: this.props.formValues.dataSource.pageSize,
                                    showTotal: (total) => `${total} Registro(s) encontrado(s).`
                                }}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)